import { host } from "config/api.config";
import { SideMenuConfig } from "model/sideMenuConfig.model";
import { useHTTPClient } from "services/httpClient.service";

const url = `${host}/config`

export function useGetMenuConfig(compnayUsername: string){
    const {data, loading, error, get} = useHTTPClient<SideMenuConfig>(`${url}/menu/${compnayUsername}`)
    return {
        data,
        loading,
        error,
        get
    }
}